import React, { Component } from 'react';
import {
    CommunityWrapper,
    FoundationBox,
    PictureBox,
    FoundationBoxTag
} from './style';
import {
    Picker,
    ProgressBar
} from 'antd-mobile'
import AntIconRadio from '../../common/radio';
import { Select } from 'antd';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import api from '../../http/api';
import axios from "axios"
import httpAxios from "../../http/httpAxios"
import UUID from 'uuid/v1';
import {
    checkVideoDurationAndSize,
} from '../../utils/utils'
import { loadScript } from '../../utils/loadScript';

const publishPictures = require('../../images/publishPictures.png');
const minPublishPictures = require('../../images/minPublishPictures.png');

const BlockEmbed = Quill.import('blots/block/embed')
export class VideoBlot extends BlockEmbed {
    static create(value) {
        let node = super.create()
        node.setAttribute('src', value.url)
        node.setAttribute('controls', value.controls)
        node.setAttribute('width', value.width)
        node.setAttribute('poster', value.poster)
        node.setAttribute('controlslist', 'nodownload noremoteplayback')
        node.setAttribute('oncontextmenu', 'return false')
        return node;
    }
    // 富文本初始化取参数，如果有编辑富文本的功能的话，这段代码就需要加上
    static value(node) {
        return {
            url: node.getAttribute('src'),
            controls: node.getAttribute('controls'),
            width: node.getAttribute('width'),
            poster: node.getAttribute('poster'),
            controlslist: node.getAttribute('controlslist'),
            oncontextmenu: node.getAttribute('oncontextmenu')
        };
    }
}
VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';
VideoBlot.className = 'ql-video';
Quill.register(VideoBlot)

class CommunityRelease extends Component {
    constructor(props) 
    { 
        super(props);
        this.reactQuillRef = null;
        this.videoInput = null;
    }

    componentDidMount() {
        var that = this;
        window.userInfo = function (data, params) {
            that.setState({
                userPID: data.UserPID
            })
        }

        //图片
        window.setImageUrl=function(imageUrl)
        {
            that.setState({
                imageCover: [...that.state.imageCover,imageUrl]
            });
        }

        //文本框里的图片
        window.setTextImageUrl=function(imageUrl)
        {
            imageUrl+="?x-oss-process=image/watermark,image_b2ZmaWNhbC9jbndhdGVybWFyay5wbmc=,g_se,x_20,y_20";

            let quill=that.reactQuillRef.getEditor();//获取到编辑器本身
            const cursorPosition =quill.getSelection().index;//获取当前光标位置
            quill.insertEmbed(cursorPosition, "image",imageUrl, Quill.sources.USER);//插入图片
            quill.setSelection(cursorPosition + 1);//光标位置加1
        }
    }

    state = {
        value: '',
        visible: false,
        basicColumns: [[
            { label: '耳机', value: '1' },
            { label: '音响', value: '2' },
            { label: '功放', value: '3' },
            { label: '播放器', value: '4' },
            { label: '音源', value: '5' },
            { label: '配件', value: '6' },
            { label: '涨知识', value: '7' },
            { label: 'DAC', value: '8' },
            { label: '定制专区', value: '9' },
        ],],
        imageSelect: {
            one: true, town: false, three: false
        },
        labelData: undefined,
        Introduce: '',
        imageCover: [],
        percent: 0,
        upcode: '',
    };

    componentDidMount() {
        var that = this;
        window.userInfo = function (data, params) {
            that.setState({
                userPID: data.UserPID
            })
        }

        //图片
        window.setImageUrl = function (imageUrl) {
            that.setState({
                imageCover: [...that.state.imageCover, imageUrl]
            });
        }

        //文本框里的图片
        window.setTextImageUrl = function (imageUrl) {
            imageUrl += "?x-oss-process=image/watermark,image_b2ZmaWNhbC9jbndhdGVybWFyay5wbmc=,g_se,x_20,y_20";

            let quill = that.reactQuillRef.getEditor();//获取到编辑器本身
            const cursorPosition = quill.getSelection().index;//获取当前光标位置
            quill.insertEmbed(cursorPosition, "image", imageUrl, Quill.sources.USER);//插入图片
            quill.setSelection(cursorPosition + 1);//光标位置加1
        }
    }

    modules = {
        toolbar: {
            container: [
                ['link', 'image', 'video'],
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                ['clean']
            ],
            handlers: {
                'image': () => {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: "uploadimages", filetype: 1 }));
                },
                'video': () => {
                    this.videoInput.click();
                }
            }
        }
    }

    // formats = [
    //     'header',
    //     'bold', 'italic', 'underline', 'strike', 'blockquote',
    //     'list', 'bullet', 'indent',
    //     'link', 'image'
    // ]

    //封面图单选
    confirmProtocol = async (type) => {
        let selectData = {
            one: false, town: false, three: false
        }
        selectData[type] = true;
        this.setState({
            imageSelect: selectData
        })

        //删除图片
        for (let index = 0; index < this.state.imageCover.length; index++) {
            const element = this.state.imageCover[index];
            await this.deleteImage(element);
        }
    }

    //标签数据
    labelChange = (value) => {
        this.setState({
            labelData: value
        });
    }

    //删除图片
    deleteImage = async (url) => {
        const res = axios.delete(api.SingleImg_Delete.url + '?imgURL=' + url)
        if (res) {
            this.setState({
                imageCover: this.state.imageCover.slice(0).filter(i => i !== url),
            })
        }
    }

    //富文本编辑器获取焦点动作
    // formatRange(range) {
    //     return range
    //         ? [range.index, range.index + range.length].join(',')
    //         : 'none';
    // }
    // onEditorFocus = (range, source) => {
    //     this.setState({
    //         events: [
    //             `[${source}] focus(${this.formatRange(range)})`
    //         ].concat(this.state.events)
    //     });
    // }

    handleVideoChange = async (e) => {
        const {
            upcode
        } = this.state;
        // let loading = () =>(message.loading('加载中', 100));
        // let hide = null;
        const file = e.target.files[0];
        const result = await checkVideoDurationAndSize(file);
        if (!result) return;
        const _this = this;
        // 按需加载阿里云上传 SDK（原 index.html 全局加载，现改为上传时加载）
        await Promise.all([
            loadScript('/lib/aliyun-upload-sdk/lib/aliyun-oss-sdk-5.3.1.min.js'),
            loadScript('/lib/aliyun-upload-sdk/aliyun-upload-sdk-1.5.0.min.js')
        ]);
        let uploader = new window.AliyunUpload.Vod({
            //阿里账号ID，必须有值 ，值的来源https://help.aliyun.com/knowledge_detail/37196.html
            userId: "1229674216664341",
            //分片大小默认1M，不能小于100K
            partSize: 1048576,
            //并行上传分片个数，默认5
            parallel: 5,
            //网络原因失败时，重新上传次数，默认为3
            retryCount: 3,
            //网络原因失败时，重新上传间隔时间，默认为2秒
            retryDuration: 2,
            //是否上报上传日志到点播，默认为true
            enableUploadProgress: true,
            // 开始上传
            'onUploadstarted': function (uploadInfo) {
                const origName = uploadInfo.file.name;
                const suffix = uploadInfo.file.name.split('.')[1];
                const name = UUID() + '.' + suffix;
                const newFile = new File([uploadInfo.file], name);
                uploadInfo.file = newFile;
                if (uploadInfo.videoId) {
                    // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
                    // hide = loading();
                    httpAxios(api.refreshUploadVideo, {
                        vid: uploadInfo.videoId
                    }).then(res => {
                        uploader.setUploadAuthAndAddress(uploadInfo, res.Data.UploadAuth, res.Data.UploadAddress, res.Data.VideoID);
                    })
                } else {
                    // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
                    // hide = loading();
                    httpAxios(api.uploadVideo, {
                        "Title": origName,
                        "FileName": name,
                        "CoverURL": '',
                        "TypeCode": 5,
                        "TemplateGroupId": ""
                    }).then(res => {
                        uploader.setUploadAuthAndAddress(uploadInfo, res.Data.UploadAuth, res.Data.UploadAddress, res.Data.VideoID);
                    })
                }
            },
            // 文件上传成功
            'onUploadSucceed': async (uploadInfo) => {
                const res = await httpAxios(api.getVideoInfo, {
                    VideoID: uploadInfo.videoId
                })
                if (res) {
                    const videoSrc = res.Data.PlayInfoList[0].PlayURL;
                    
                    let quill = _this.reactQuillRef.getEditor();//获取到编辑器本身
                    let index = quill.selection.savedRange.index;//光标

                    quill.insertEmbed(index, "video", {
                        url: videoSrc,
                        controls: 'controls',
                        width: '100%',
                    });//插入视频
                    quill.setSelection(index + 1);//光标位置加1
                }
            },
            // 文件上传失败
            'onUploadFailed': function (uploadInfo, code, message) {
                let upcode = code;
                _this.setState({ upcode });
                // log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message);
            },
            // 文件上传进度，单位：字节
            'onUploadProgress': function (uploadInfo, totalSize, loadedPercent) {
                let percent = Math.ceil(loadedPercent * 100);
                _this.setState({ percent });
                //log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(loadedPercent * 100) + "%");
            },
            // 上传凭证超时
            'onUploadTokenExpired': function (uploadInfo) {
                //实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
                //https://help.aliyun.com/document_detail/55408.html
                //从点播服务刷新的uploadAuth,设置到SDK里
                // uploader.resumeUploadWithAuth(uploadAuth);
            },
            //全部文件上传结束
            'onUploadEnd': function (uploadInfo) {                
            }
        })
        uploader.addFile(file, null, null, null); // 添加文件
        uploader.startUpload(); // 开始上传
    }
    render() {
        const {
            value,
            visible,
            basicColumns,
            imageSelect,
            labelData,
            Introduce,
            imageCover,
            percent,
            upcode,
        } = this.state;
        return (
            < CommunityWrapper >
                <FoundationBox
                    onClick={() => {
                        this.setState({
                            visible: true
                        })
                    }}
                >
                    {
                        value ? value : '选择分类'
                    }
                    <i className='iconfont'>&#xe7b6;</i>
                    <Picker
                        columns={basicColumns}
                        visible={visible}
                        onClose={() => {
                            this.setState({
                                visible: false
                            })
                        }}
                        value={value}
                        onConfirm={v => {
                            this.setState({
                                value: v
                            })
                        }}
                    />
                </FoundationBox>
                <FoundationBox>
                    <input placeholder='此处填写标题（5～70个字）' />
                </FoundationBox>
                <PictureBox>
                    <div className='picture_title'>封面图展示</div>
                    <div className='picture_radio'>
                        <AntIconRadio
                            selected={imageSelect.one}
                            onChange={() => { this.confirmProtocol('one') }}
                            text={'一张封面图'}
                        />
                        <AntIconRadio
                            selected={imageSelect.town}
                            onChange={() => { this.confirmProtocol('town') }}
                            text={'三张封面图'}
                        />
                        <AntIconRadio
                            selected={imageSelect.three}
                            onChange={() => { this.confirmProtocol('three') }}
                            text={'无封面图'}
                        />
                    </div>
                    {imageSelect.one &&
                        <>
                            {imageCover.length == 0 &&
                                <div className='picture_one_img' onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "uploadimages", filetype: 0 })); }}>
                                    <img src={publishPictures}></img>
                                </div>
                            }
                            {imageCover.length > 0 &&
                                <div className='picture_one_img' onClick={async () => { await this.deleteImage(imageCover[0]); }}>
                                    <img src={imageCover[0]}></img>
                                </div>
                            }
                        </>
                    }
                    {imageSelect.town &&
                        <>
                            {imageCover.map((item, index) => (
                                <div className='picture_three_img' key={index} onClick={async () => { await this.deleteImage(item); }}>
                                    <img src={item}></img>
                                </div>
                            ))}
                            {imageCover.length < 3 &&
                                <div className='picture_three_img' onClick={() => { window.ReactNativeWebView.postMessage(JSON.stringify({ type: "uploadimages", filetype: 0 })); }}>
                                    <img src={minPublishPictures}></img>
                                </div>
                            }
                        </>
                    }
                </PictureBox>
                <FoundationBoxTag>
                    <Select
                        placeholder="添加标签.例如:品牌、型号、产品类型等"
                        mode="tags"
                        style={{ width: "100%" }}
                        onChange={this.labelChange}
                        open={false}
                        value={labelData}
                    />
                </FoundationBoxTag>
                <FoundationBoxTag>
                    <ReactQuill className='editor-container'
                        theme="snow"
                        ref={(el) => { this.reactQuillRef = el }}
                        placeholder='在此处填写正文'
                        modules={this.modules}
                        // formats={this.formats}
                        value={Introduce}
                        // onFocus={this.onEditorFocus}
                        onChange={(value) => this.setState({ Introduce: value })
                        }
                    />
                </FoundationBoxTag>
                {percent > 0 && <ProgressBar percent={percent} text={`${upcode.length > 0 ? 'exception' : ''}`} />}
                <input type="file" accept='video/*' hidden ref={r => this.videoInput = r} onChange={this.handleVideoChange} />
            </CommunityWrapper >
        )
    }
}

export default CommunityRelease